import React, { useState, useContext } from "react";
// import { useDispatch } from "react-redux";
// import { useLocation } from "react-router-dom";

// import { setRequestID } from "../store/modules/RuleStore";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [primaryColor] = useState("azulMedio");
  const [secundaryColor] = useState("#f5faff");
  const [color3] = useState("#DCE6E6");
  const [color4] = useState("lila");
  const [color5] = useState("amarillo");
  const [color6] = useState("medianoche");
  const [color7] = useState("space");

  const [newRequestRedirect, setNewRequestRedirect] = useState(false);

  const [currentRequestID, setCurrentRequestID] = useState("");

  const [isDropdownActive, setIsDropdwonActive] = useState(false);

  //   const pathname = useLocation().pathname;

  //   const dispatch = useDispatch();

  //   if (pathname !== `/request/${currentRequestID}`) {
  //     dispatch(setRequestID(""));
  //   }

  //   useEffect(() => {
  //     if (pathname !== `/request/${currentRequestID}`) {
  //       dispatch(setRequestID(""));
  //     }
  //   }, [pathname, currentRequestID]);

  return (
    <AppContext.Provider
      value={{
        primaryColor,
        secundaryColor,
        color3,
        color4,
        color5,
        color6,
        color7,
        currentRequestID,
        setCurrentRequestID,
        newRequestRedirect,
        setNewRequestRedirect,
        isDropdownActive,
        setIsDropdwonActive,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// custom hook
export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppProvider };
